/**
 * 课件列表功能
 * @Author:wuTao
 */
import React from 'react';
import {connect} from 'dva';
import {reduxTemplateCofig, templateConfig} from './config';

import {framework_tool,component_tool} from '@/tool';

let {WizContainer, WizReduxTemplate} = framework_tool;
let { WizBrowserExport } = component_tool;

class ScheduleList extends WizContainer {

  componentName = 'ScheduleList';

  constructor(props) {
    super(props);
    this.state = {}
  }

  /**
   * 页面动作操作后进行提示
   * @param nextProps
   * @param nextState
   * @param key
   * @returns {boolean}
   * @private
   */
  _handleSchedule(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg']);
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }


  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '课件名称',
        field: 'name',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '编号',
        field: 'code',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '文件格式',
        field: 'typeName',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '防挂机时长(分)',
        field: 'preventOnHook',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '时长(分)',
        field: 'duration',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '支持平台',
        field: 'supportsName',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '状态',
        field: 'statusName',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      // {
      //   headerName: '截止时间',
      //   field: 'endTime',
      //   width: 20,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'center' },
      //   },
      // },
      {
        headerName: '创建时间',
        field: 'createTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      }
    ]
    if (o['success']) {
      let data = o['data']['exportData']
      WizBrowserExport({
        title: '课件信息',
        sheetName: '课件信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '课件信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig,
      apiDataFormat: {
        add: this._handleSchedule,
        update: this._handleSchedule,
        delete: this._handleSchedule,
        updateScheduleStatus: this._handleSchedule,
        export: this._handleFile,
        look: this._handleSchedule,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(ScheduleList);
